import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import { IBookOfMindState } from "source/app/presentation/MainPanel/Workflows/BookOfMind/Helpers/IBookOfMindState";
import {
    RefreshBookOfMindQuotes,
    SelectNextBookOfMindQuotesBatch,
} from "source/app/presentation/MainPanel/Workflows/BookOfMind/Tools/BookOfMindTools";
import { ReadState } from "../../../../../../../services/UI/State/ReadState";
import { SetBookOfMindState } from "../../../Helpers/BookOfMindHelpers";
import { bookOfMindSpeech } from "../../../Speech/BookOfMindSpeech";

export function HandleBookOfMindTurnPageRequest() {
    // Invalidate the current page audio before the next page is rendered. The
    // display effect also stops speech after the state update, but that is too
    // late for a quick click on the new page's audio control to accidentally
    // resume the previous page's blob.
    bookOfMindSpeech.StopPageAudio("page-turn");

    const bookOfMind = ReadState<IBookOfMindState>(ESharedFunction.BookOfMind);

    if (!bookOfMind) {
        return;
    }

    const shouldRefreshAllQuotes =
        bookOfMind.remainingQuotesToDisplay.length <=
        bookOfMind.numberOfQuotesToDisplay;

    SetBookOfMindState({ selectedQuote: undefined });

    if (shouldRefreshAllQuotes) {
        RefreshBookOfMindQuotes();
    } else {
        SelectNextBookOfMindQuotesBatch();
    }
}
